// @flow

export default (interval: string): boolean => interval === 'year';
